module.exports = __webpack_public_path__ + "img/gongyu.95a69875.jpg";